<template>
    <el-card class="reportsList">
        <div style=" font-size: 16px;
        font-weight: 900;">问题报表细化</div>
        <ul>
            <router-link :to="{path:'/problemStatus'}">
                <li>问题状态优先级紧急度统计</li>
            </router-link>
            <router-link :to="{path:'/proStatusUser'}">
                <li>问题状态用户统计</li>
            </router-link>
            <router-link :to="{path:'/proStatusUserGroup'}">
                <li>问题状态用户按组统计</li>
            </router-link>
        </ul>
    </el-card>
</template>

<script>
    export default {

    }
</script>

<style scoped>
    .reportsList{
        /*height: 120px;*/
        background: white;
        font-size: 15px;
    }
    .reportsList div{
        padding-left: 15px;
    }
    .reportsList ul{
        float: left;
        margin: 20px 10px 10px 10px;

    }
    .reportsList ul li{
        color: grey;
        float: left;
        margin: 5px 35px 5px 5px;
    }
</style>
